var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6678 10.2083L16.822 7.24144C16.472 6.01877 15.135 5.29311 13.833 5.61977L7.35098 7.25311C6.04898 7.57977 5.27664 8.83744 5.62431 10.0601L7.67764 17.2584C8.02764 18.4811 9.36464 19.2068 10.6666 18.8801L11.3748 18.7016M17.6678 10.2083H13.7081C13.0893 10.2083 12.4958 10.4541 12.0582 10.8917C11.6206 11.3293 11.3748 11.9228 11.3748 12.5416V18.7016M17.6678 10.2083H20.1248C20.7436 10.2083 21.3371 10.4541 21.7747 10.8917C22.2123 11.3293 22.4581 11.9228 22.4581 12.5416V20.1249C22.4581 20.7438 22.2123 21.3373 21.7747 21.7749C21.3371 22.2124 20.7436 22.4583 20.1248 22.4583H13.7081C13.0893 22.4583 12.4958 22.2124 12.0582 21.7749C11.6206 21.3373 11.3748 20.7438 11.3748 20.1249V18.7016",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards2);
export default __webpack_public_path__ + "static/media/cards-2.506e9c00e1400f9fcf209d4ee123284b.svg";
export { ForwardRef as ReactComponent };